import vehicleInsideImg from './../../assets/images/vehicle-inside.svg'
import vehicleFrontImg from './../../assets/images/vehicle-front.svg'
import vehicleSideImg from './../../assets/images/vehicle-left-side.svg'
import vehicleRearImg from './../../assets/images/vehicle-rear.svg'
import vehicleSideRightImg from './../../assets/images/vehicle-right-side.svg'

import { updateWithAccessToPreviousState } from '../utils/updateWithAccessToPreviousState'
import { StateCreator } from 'zustand'

export interface IVehicleData {
  [key: number]: {
    defaultPlaceholder: string
    placeholder: string
    photo: string | null
    date: string | null
  }
}

const vehicleInitialData: IVehicleData = {
  0: {
    defaultPlaceholder: vehicleInsideImg,
    placeholder: '',
    photo: null,
    date: null,
  },
  1: {
    defaultPlaceholder: vehicleFrontImg,
    placeholder: '',
    photo: null,
    date: null,
  },
  2: {
    defaultPlaceholder: vehicleSideImg,
    placeholder: '',
    photo: null,
    date: null,
  },
  3: {
    defaultPlaceholder: vehicleRearImg,
    placeholder: '',
    photo: null,
    date: null,
  },
  4: {
    defaultPlaceholder: vehicleSideRightImg,
    placeholder: '',
    photo: null,
    date: null,
  },
}

export interface VehicleDataSlice {
  vehicleData: typeof vehicleInitialData
  setVehicleData: (payload: typeof vehicleInitialData) => void
}

export const createVehicleDataSlice: StateCreator<VehicleDataSlice> = (
  set
) => ({
  vehicleData: vehicleInitialData,
  setVehicleData: (payload) =>
    updateWithAccessToPreviousState(set, 'vehicleData', payload),
})

export default createVehicleDataSlice
